export const removeRelAttribute = (inputString) => {
  const relPattern =
    /(<a\shref="https:\/\/(?:dash|www).driva.co.nz[^>]*?)(\srel="(?:(?:nofollow\s)?noopener\snoreferrer"))/g;
  const outputString = inputString.replace(relPattern, '$1');
  return outputString;
};
